import { render, staticRenderFns } from "./CertResult.vue?vue&type=template&id=1476d151&scoped=true"
import script from "./CertResult.vue?vue&type=script&lang=js"
export * from "./CertResult.vue?vue&type=script&lang=js"
import style0 from "./CertResult.vue?vue&type=style&index=0&id=1476d151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1476d151",
  null
  
)

export default component.exports